import ErrorBoundary from "components/ErrorBoundary";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Container } from "rebass";
import { bindActionCreators } from "redux";
import { selectCourse } from "../../ducks/user";
import CourseSelectForm from "./CourseSelectForm";

class CourseSelect extends React.Component {
  render() {
    const { currentCourse, defaultCourse, selectCourse, courseData } = this.props;

    return (
      <Container mb={[8, 8, 7]} textAlign="center">
        <ErrorBoundary>
          <CourseSelectForm
            currentCourse={currentCourse}
            defaultCourse={defaultCourse}
            selectCourse={selectCourse}
            courseData={courseData}
          />
        </ErrorBoundary>
      </Container>
    );
  }
}

CourseSelect.propTypes = {
  searchTerms: PropTypes.object,
  updateApplicantSearchTerms: PropTypes.func,
  courseData: PropTypes.object,
};

const mapStateToProps = (state) => {
  const courseUnit = state.userState.user ? state.userState.user.office : "";
  return {
    currentCourse: state.userState.currentCourse,
    defaultCourse: {
      courseYear: "" + new Date().getFullYear(),
      courseUnit,
      courseNumber: "",
    },
    courseData: state.userState.courseData
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectCourse: (course) => {
        return selectCourse(course);
      },
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CourseSelect);



// WEBPACK FOOTER //
// ./src/containers/course/index.js